import React, { Component } from "react";
import { Icon } from "@culturehq/components";

const Option = ({ body, isActive, onSelect }) => {
  const activeClass = isActive ? "active" : "inactive";
  const icon = isActive ? "android-checkbox-outline" : "android-checkbox-outline-blank";

  return (
    <div className={`option star ${activeClass}`} onClick={onSelect} role="button" tabIndex={0} aria-label={body}>
      <Icon icon={icon} />
      <span>{body}</span>
    </div>
  );
};

class MultiChoiceManyItem extends Component {
  constructor(props) {
    super(props);

    const { submittedResponse } = props;
    const { surveyItemResponseOptions } = submittedResponse || {};

    const surveyItemResponseOptionIds = (surveyItemResponseOptions || []).map(({ id }) => id);
    this.state = { surveyItemResponseOptionIds };
  }

  handleChange = surveyItemResponseOptionId => {
    const { onChange, surveyItem } = this.props;

    this.setState(({ surveyItemResponseOptionIds: currentResponseOptionIds }) => {
      let surveyItemResponseOptionIds;

      if (currentResponseOptionIds.includes(surveyItemResponseOptionId)) {
        surveyItemResponseOptionIds = currentResponseOptionIds.filter(id => (
          id !== surveyItemResponseOptionId
        ));
      } else {
        surveyItemResponseOptionIds = [
          ...currentResponseOptionIds,
          surveyItemResponseOptionId
        ];
      }

      if (onChange) {
        onChange({ surveyItemId: surveyItem.id, surveyItemResponseOptionIds });
      }

      return { surveyItemResponseOptionIds };
    });
  };

  render() {
    const { surveyItem: { responseOptions } } = this.props;
    const { surveyItemResponseOptionIds } = this.state;

    return (
      <div className="SurveyItemMultiChoice SurveyItemMultiChoiceMany">
        <div className="options">
          {responseOptions.map(({ id, body }) => (
            <Option
              key={id}
              body={body}
              isActive={surveyItemResponseOptionIds.includes(id)}
              onSelect={() => this.handleChange(id)}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default MultiChoiceManyItem;
